(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-mom-playbook"] && !Shopify.designMode) return;
  try {
    
function nmpSingleCopyPlan(cart,variantId) {
 const lines=cart.items.filter(item=>String(item.variant_id)===String(variantId));
 const updates={};
 lines.forEach((item,index)=>{const quantity=index===0?1:0;if(item.quantity!==quantity)updates[item.key]=quantity;});
 return {add:lines.length===0,updates};
}

class NewMomPlaybook extends HTMLElement {
 resetCheckout(clearStatus=true){
  this.nmpBuying=false;
  if(this.nmpButtonStates){
   this.nmpButtonStates.forEach(({button,disabled})=>{button.disabled=disabled;});
   this.nmpButtonStates=null;
  }
  this.removeAttribute('aria-busy');
  if(clearStatus)this.querySelectorAll('[data-nmp-cart-status]').forEach(status=>status.textContent='');
 }
 disconnectedCallback(){window.removeEventListener('pageshow',this.nmpPageShow);}
 connectedCallback(){
  if(!this.nmpPageShow)this.nmpPageShow=()=>this.resetCheckout();
  window.addEventListener('pageshow',this.nmpPageShow);
  if(this.nmpReady){this.resetCheckout();return;}this.nmpReady=true;
  this.addEventListener('submit', async event => {
   const form=event.target;
   if(!form.matches('.nmp-product-form,.nmp-bottom-form,.nmp-sticky-form'))return;
   event.preventDefault();
   event.stopImmediatePropagation();
   if(this.nmpBuying)return;
   this.nmpBuying=true;
   const buttons=Array.from(this.querySelectorAll('button[type="submit"]'));
   this.nmpButtonStates=buttons.map(button=>({button,disabled:button.disabled}));
   buttons.forEach(button=>button.disabled=true);
   this.setAttribute('aria-busy','true');
   let status=form.querySelector('[data-nmp-cart-status]');
   if(!status){status=document.createElement('p');status.dataset.nmpCartStatus='';status.className='nmp-cart-status';status.setAttribute('role','status');form.append(status);}
   status.textContent=this.dataset.loadingLabel;
   const root=(window.Shopify?.routes?.root||this.dataset.cartRoot||'/').replace(/\/?$/,'/');
   const request=async (path,body)=>{
    const response=await fetch(root+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    if(!response.ok)throw new Error('Cart request failed');
    return response.json();
   };
   const variantId=new FormData(form).get('id');
   const prepare=async()=>{
    if(!variantId)throw new Error('Missing variant');
    const cart=await request('cart.js');
    const plan=nmpSingleCopyPlan(cart,variantId);
    if(Object.keys(plan.updates).length)await request('cart/update.js',{updates:plan.updates});
    if(plan.add)await request('cart/add.js',{items:[{id:variantId,quantity:1}]});
    const verified=await request('cart.js');
    const quantity=verified.items.filter(item=>String(item.variant_id)===String(variantId)).reduce((total,item)=>total+item.quantity,0);
    if(quantity!==1)throw new Error('Unexpected quantity');
    window.location.assign(root+'checkout');
   };
   try {
    if(navigator.locks?.request)await navigator.locks.request('nmp-single-copy-checkout',prepare);
    else await prepare();
   } catch(error) {
    status.textContent=this.dataset.errorLabel+' ';
    const link=document.createElement('a');link.href=root+'cart';link.textContent=this.dataset.cartLabel;status.append(link);
    this.resetCheckout(false);
   }
  },true);
const gallery=this.querySelector('[data-nmp-gallery]');const move=direction=>{if(!gallery||!gallery.firstElementChild)return;const gap=parseFloat(getComputedStyle(gallery).columnGap)||0;gallery.scrollBy({left:direction*(gallery.firstElementChild.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};this.querySelector('[data-nmp-prev]')?.addEventListener('click',()=>move(-1));this.querySelector('[data-nmp-next]')?.addEventListener('click',()=>move(1));gallery?.addEventListener('keydown',event=>{if(event.target===gallery&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}});this.querySelector('[data-nmp-variants]')?.addEventListener('change',event=>{const option=event.target.selectedOptions[0];this.querySelectorAll('[data-nmp-checkout-variant]').forEach(input=>input.value=option.value);this.querySelectorAll('[data-nmp-price]').forEach(node=>node.textContent=option.dataset.price)})}
}
if(!customElements.get('new-mom-playbook'))customElements.define('new-mom-playbook',NewMomPlaybook);


  } catch(e) { console.error(e); }
})();
})();
